import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import theme from 'shared/styles/theme';

const NearbyLoading = () => (
  <View style={styles.container}>
    <LoadingSpinner />
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacing.m,
  },
});

export default NearbyLoading;
